<template>
	<div class="card">
		<div class="card-content">
			<div class="media">
				<div class="media-left">
					<figure class="image is-48x48">
						<img
							:alt="review.author_name + ' avatar'"
							:src="getReviewAvatar(review.plattform)"
						/>
					</figure>
				</div>
				<div class="media-content">
					<p class="title is-5">
						<rate-component :value="review.rating" disabled></rate-component>
					</p>
					<p class="subtitle is-6 is-italic"> am {{ formatDate(review.transaction_at) }}</p>
				</div>
			</div>

			<div class="content">
				<b v-if="review.title">{{ review.title }}<br></b>
				{{ review.description }}
				<p v-if="review.author_name"><i>- {{ review.author_name }}</i></p>
			</div>
			<div v-if="show_plattform">
				<a :href="review.profile_url" target="_blank">Zu {{ review.plattform }}</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ReviewsItem',
	props: {
		review: {
			type: Object,
			required: true,
		},
		show_plattform: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		getReviewAvatar(plattform) {
			switch (plattform) {
				case 'TrustedShops':
					return require('@/assets/reviews/trustedshops.png');
				case 'Trustpilot':
					return require('@/assets/reviews/trustpilot.png');
				// case 'Google':
				// 	return require('@/assets/reviews/google.png');
				// case 'Facebook':
				// 	return require('@/assets/reviews/facebook.png');
				case 'Proven-expert':
					return require('@/assets/reviews/provenexpert.png');
				case 'Ekomi':
					return require('@/assets/reviews/ekomi.png');
				default:
					return null;
			}
		},
		formatDate(dateString) {
			const options = {year: 'numeric', month: '2-digit', day: '2-digit'};
			return new Date(dateString).toLocaleDateString('de-DE', options);
		},
	},
};
</script>

<style scoped>
/* Zusätzliche CSS-Stile für Buefy/Bulma können hier hinzugefügt werden */
</style>
